
document.addEventListener('DOMContentLoaded', () => {

    function equalArrays(a,b) {
      if (a.length != b.length) return false;
    
     for(var i = 0; i < a.length; i++)
       if (a[i] !== b[i]) return false;
    
     return true;
    }

    const Products = document.querySelectorAll('[product]');

    if(Boolean(Products)){
      Products.forEach((Product)=>{
        const ProductForm = Product.querySelector('form[action="/cart/add"], form[action="/he/cart/add"]');
        const ProductAddToCart = Product.querySelector('[product-add-to-cart]');
        const Variables = Product.querySelectorAll('[data-selected-options]');

        const ProductQuantity = Product.querySelector('[product-quantity]');
        if(Boolean(ProductQuantity)){

          ProductForm.addEventListener('keydown', function(event) {
              if(event.keyCode == 13) {
                 event.preventDefault();
              }
           });
          
          const ProductQuantityLenghtInput = ProductQuantity.querySelector('[product-input-quantity-length]');
          const ProductQuantityInput = ProductQuantity.querySelector('[product-input-quantity]');
          const ProductQuantityMinus = ProductQuantity.querySelector('[product-btn-quantity-minus]');
          const ProductQuantitytPlus = ProductQuantity.querySelector('[product-btn-quantity-plus]');

          if(Boolean(ProductQuantityInput)){
            
            ProductQuantityMinus.addEventListener('click', ()=>{
              if(Number(ProductQuantityInput.value) - Number(ProductQuantityInput.step) >= Number(ProductQuantityInput.min)){
                ProductQuantityInput.value = Math.round(Number(ProductQuantityInput.value) - Number(ProductQuantityInput.step))
              }else{
                ProductQuantityInput.value = Math.round(Number(ProductQuantityInput.min));
              }
            })
        
            ProductQuantitytPlus.addEventListener('click', ()=>{
              if(Number(ProductQuantityInput.value) + Number(ProductQuantityInput.step) <= Number(ProductQuantityInput.max)){
                ProductQuantityInput.value = Math.round(Number(ProductQuantityInput.value) + Number(ProductQuantityInput.step)) 
              }else{
                ProductQuantityInput.value = Math.round(Number(ProductQuantityInput.max));
              }
            })
        
            ProductQuantityInput.addEventListener('change', ()=>{
              if(Number(ProductQuantityInput.value) <= Number(ProductQuantityInput.min)){
                ProductQuantityInput.value = Number(ProductQuantityInput.min);
              }
              if(Number(ProductQuantityInput.value) >= Number(ProductQuantityInput.max)){
                ProductQuantityInput.value = Number(ProductQuantityInput.max);
              }
              ProductQuantityInput.value = Math.round(ProductQuantityInput.value);
            })
            
          }else if(Boolean(ProductQuantityLenghtInput)){

            
            
            ProductQuantityMinus.addEventListener('click', ()=>{
              if(Number(ProductQuantityLenghtInput.value) - Number(ProductQuantityLenghtInput.step) >= Number(ProductQuantityLenghtInput.min)){
                ProductQuantityLenghtInput.value = Number(ProductQuantityLenghtInput.value) - Number(ProductQuantityLenghtInput.step)
              }else{
                ProductQuantityLenghtInput.value = Number(ProductQuantityLenghtInput.min);
              }
              ProductQuantityLenghtInput.value = roundToHalf(Number(ProductQuantityLenghtInput.value))
            })
        
            ProductQuantitytPlus.addEventListener('click', ()=>{
              if(Number(ProductQuantityLenghtInput.value) + Number(ProductQuantityLenghtInput.step) <= Number(ProductQuantityLenghtInput.max)){
                ProductQuantityLenghtInput.value = Number(ProductQuantityLenghtInput.value) + Number(ProductQuantityLenghtInput.step)
              }else{
                ProductQuantityLenghtInput.value = Number(ProductQuantityLenghtInput.max);
              }
              ProductQuantityLenghtInput.value = roundToHalf(Number(ProductQuantityLenghtInput.value))
            })
        
            ProductQuantityLenghtInput.addEventListener('change', ()=>{
              if(Number(ProductQuantityLenghtInput.value) <= Number(ProductQuantityLenghtInput.min)){
                ProductQuantityLenghtInput.value = Number(ProductQuantityLenghtInput.min);
              }
              if(Number(ProductQuantityLenghtInput.value) >= Number(ProductQuantityLenghtInput.max)){
                ProductQuantityLenghtInput.value = Number(ProductQuantityLenghtInput.max);
              }

              ProductQuantityLenghtInput.value = roundToHalf(Number(ProductQuantityLenghtInput.value))
              
            })
          }

        }

        if(Boolean(ProductAddToCart)){
        
          ProductAddToCart.addEventListener('click', ()=>{
            const ProductSpinner = Product.querySelector('[product-overflow-spinner]');
            const ProductVariantID = ProductForm.querySelector('[name="id"]').value;
            const ProductQuantity = Product.querySelector('[product-quantity]');
            const ProductQuantityLenghtInput = ProductQuantity.querySelector('[product-input-quantity-length]');
            const ProductQuantityInput = ProductQuantity.querySelector('[product-input-quantity]');
            
            console.log(ProductQuantityLenghtInput);
            if(Boolean(ProductQuantityLenghtInput)){
              ProductAddToCart.dataset.addedInCart = 'true';
              console.log(ProductQuantityLenghtInput);
              AddToCart(ProductVariantID, 1, ProductQuantityLenghtInput.value).then((data)=>{
                Product.dataset.inCart = 'true';
                ProductAddToCart.dataset.addedInCart = 'false';
              })
            }else{
              ProductAddToCart.dataset.addedInCart = 'true';
              AddToCart(ProductVariantID, ProductQuantityInput.value,).then((data)=>{
                Product.dataset.inCart = 'true';
                ProductAddToCart.dataset.addedInCart = 'false';
              })
            }
            
          })
        }  

        const ButtonSaveToWishlist = Product.querySelector('[product-btn-toggle-wishlist]')
        const ProductID = ButtonSaveToWishlist.dataset.productId
        const wl = Wishlist({ product_id: ProductID, toggle_wishlist: ButtonSaveToWishlist });
    
        ButtonSaveToWishlist.addEventListener('click', (e) => {
        e.preventDefault()
        
        let index = wl.getIndex()
      
        if (index === -1) {
          wl.add(ProductID)
          ButtonSaveToWishlist.classList.add('active')
        } else {
          wl.remove()
          ButtonSaveToWishlist.classList.remove('active')
        }
      
        })

        if(Boolean(Variables)){
          Variables.forEach((Variable)=>{

            const VariablesOptions = Variable.querySelectorAll('[data-variables-option-name]');
            
            if(Boolean(VariablesOptions)){
    
              
              
              const VariantOptions = Variable.querySelector('[variants-options]');
              const VariantOptionsJson = JSON.parse(VariantOptions.textContent);
              let OptionsSelected = []; 
              
              const updateSelectedOptions = () => {
                const OptionItemsAll = Variable.querySelectorAll('[data-variables-option-value-name][data-variables-option-value-selected="true"]');
                OptionsSelected = [];
                OptionItemsAll.forEach((OptionItem)=>{
                  OptionsSelected.push(OptionItem.dataset.variablesOptionValueName);
                })
                Variable.dataset.selectedOptions = JSON.stringify(OptionsSelected);
                updateSelectedVariant();
              }

              

              const updateSelectedVariant = () => {
                const SelectedOptions = JSON.parse(Variable.dataset.selectedOptions);
                const SelectedVariant = Object.values(VariantOptionsJson).filter((variant)=>{
                  return equalArrays(SelectedOptions, variant.options)
                })[0];
                ProductForm.querySelector('input[name="id"]').value = SelectedVariant.variant.id;
                
                const url = new URL(window.location);
                url.searchParams.set('variant', SelectedVariant.variant.id)
                history.pushState(null, '', url);

                Product.dataset.productAvaliable = SelectedVariant.variant.available;

                getShopCart()
                .then((data)=>{
                  if(data.items.filter((item)=>{
                   return item.variant_id == SelectedVariant.variant.id
                  }).length > 0){
                    Product.dataset.inCart = 'true';
                  }else{
                    Product.dataset.inCart = 'false';
                  }
                  
                })
                
              }
              
              VariablesOptions.forEach((Option)=>{
    
                const OptionItems = Option.querySelectorAll('[data-variables-option-value-name]');
    
                OptionItems.forEach((OptionItem)=>{
                  OptionItem.addEventListener('click', ()=>{
                    
                    OptionItems.forEach((item)=>{
                      item.dataset.variablesOptionValueSelected = 'false';
                    })
                    OptionItem.dataset.variablesOptionValueSelected = 'true';

                    updateSelectedOptions();
                    
                  })
                })
                
              })
            }
            
          })
        }

        const TableSizesButtonOpen = Product.querySelector('[table-sizes-btn]');
        const TableSizesPopup = Product.querySelector('[table-sizes-popup]');

        if(Boolean(TableSizesPopup)){

          const TableSizesPopupClose = TableSizesPopup.querySelector('[table-sizes-popup-close]');
          const TableSizesPopupOverflow = TableSizesPopup.querySelector('[table-sizes-popup-overflow]');
          
          if(Boolean(TableSizesButtonOpen)){
            TableSizesButtonOpen.addEventListener('click', ()=>{
              TableSizesPopup.style.display = 'block'
            })
          }

        if(Boolean(TableSizesPopupClose)){
          TableSizesPopupClose.addEventListener('click', ()=>{
            console.log(TableSizesPopup.style.diplay);
              TableSizesPopup.style.display = 'none'
            })
        }
        if(Boolean(TableSizesPopupOverflow)){
          TableSizesPopupOverflow.addEventListener('click', ()=>{
              TableSizesPopup.style.display = 'none'
            })
        }
          
        }else{
          if(Boolean(TableSizesButtonOpen)){
            TableSizesButtonOpen.style.display = 'none';
          }
        }

        const ProductGalleryMobileSlider = Product.querySelector('[product-gallery-mobile-slider]'); 
          if(Boolean(ProductGalleryMobileSlider)){
            const ProductGalleryMobileSlider_swiper = new Swiper(ProductGalleryMobileSlider, {
                loop: true,
                spaceBetween: 10,
                pagination: {
                  el: ".swiper-pagination",
                  type: "progressbar",
                },
                navigation: {
                  nextEl: ProductGalleryMobileSlider.querySelector('[product-gallery-mobile-slider-btn-next]'),
                  prevEl: ProductGalleryMobileSlider.querySelector('[product-gallery-mobile-slider-btn-prev]'),
                }
              });
        }


        const ProductGalleryPopup = Product.querySelector('[product-gallery-popup]');
        if(Boolean(ProductGalleryPopup)){
          const ProductGalleryPopupSlider = ProductGalleryPopup.querySelector('[product-gallery-popup-slider]');
          if(Boolean(ProductGalleryPopupSlider)){
              const ProductGalleryPopupSlider_swiper = new Swiper(ProductGalleryPopupSlider, {
                loop: true,
                pagination: {
                  el: ".swiper-pagination",
                  type: "progressbar",
                },
                navigation: {
                  nextEl: ProductGalleryPopupSlider.querySelector('[product-gallery-popup-slider-btn-next]'),
                  prevEl: ProductGalleryPopupSlider.querySelector('[product-gallery-popup-slider-btn-prev]'),
                }
              });

              const ProductGalleryImages = Product.querySelectorAll('[product-gallery-open-popup-slider]');
              ProductGalleryImages.forEach((gallery_image)=>{
                gallery_image.addEventListener('click', ()=>{
                  if(gallery_image.dataset.imageId){
                    const CurrentSlide = ProductGalleryPopupSlider.querySelector('[data-image-id="'+gallery_image.dataset.imageId+'"]');
                    ProductGalleryPopupSlider_swiper.slideTo(CurrentSlide.dataset.swiperSlideIndex, 0)
                    ProductGalleryPopup.style.display = 'block';
                    console.log(CurrentSlide.dataset.swiperSlideIndex);
                  }
                  
                })
                
              })
            
            }

            const ProductGalleryPopupClose = ProductGalleryPopup.querySelector('[product-gallery-popup-btn-close]');
            ProductGalleryPopupClose.addEventListener('click', ()=>{
              ProductGalleryPopup.style.display = 'none'
            })
          
          }
          
          
        
        
      });
    
    };
  
})